import * as React from 'react';
import { useMemo } from 'react';

import { IconName } from '@canvas-logic/clp-shared-ui';
import { MenuListItem } from '@/ui-kit/components/MenuList/MenuListItem';
import { useGetPdf } from '@/ui-kit/hooks/use-get-pdf';
import { useTranslation } from 'react-i18next';

interface IProps {
  className?: string;
  label: string;
}

export const PdfDownloadMenuItem = ({ label, className }: IProps) => {
  const { state, generate } = useGetPdf();
  const { t } = useTranslation('translation');

  const buttonIcon: IconName = useMemo(() => {
    switch (state) {
      case 'idle':
        return 'pdf';
      case 'ready':
        return 'check';
      case 'loading':
        return 'spinner';
    }
  }, [state]);

  return (
    <MenuListItem
      className={className}
      icon={buttonIcon}
      label={state === 'ready' ? t('buttons.pdfDownloadStarted') : label}
      onClick={generate}
      loading={state === 'loading'}
    />
  );
};
